import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMouseClassic2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="mouse-classic-2, click"><path d="M19 15C19 18.8659 15.866 22 12 22C8.13404 22 5.00005 18.8659 5 15V10.5H19V15Z" fill="currentColor"/><path d="M11.25 9H5V2.75C5 2.55111 5.0791 2.36037 5.21973 2.21973C5.36038 2.07908 5.55109 2 5.75 2H11.25V9Z" fill="currentColor"/><path d="M18.25 2C18.6642 2.00001 18.9999 2.33587 19 2.75V9H12.75V2H18.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMouseClassic2;
